__webpack_require__.p = "/skarbnik/";